module.exports = __webpack_public_path__ + "static/media/00houseextrvs.b4abeb32.webp";